import { render, staticRenderFns } from "./Food_menuPublic.vue?vue&type=template&id=5c8e16a2&scoped=true&"
import script from "./Food_menuPublic.vue?vue&type=script&lang=js&"
export * from "./Food_menuPublic.vue?vue&type=script&lang=js&"
import style0 from "./Food_menuPublic.vue?vue&type=style&index=0&id=5c8e16a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c8e16a2",
  null
  
)

export default component.exports